import * as styles from "./NotesTab.css";

import type { JSX } from "react";

import { NotesSection } from "./NotesSection";

export function NotesTab(): JSX.Element {
  return (
    <div className={styles.tab}>
      <NotesSection />
    </div>
  );
}
